var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHospitalinfoLodging = function SvgHospitalinfoLodging(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#BCBCBC",
    d: "M25.46 18.01h-19v6h19z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#D6D6D6",
    d: "M13.46 18h-7v-3h4c1.66.01 3 1.35 3 3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#4C4C4C",
    d: "M6.83 13.03h-.75v13h.75zM25.83 13.03h-.75v13h.75z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#999",
    d: "M6.44 26.98a1 1 0 1 0 0-2 1 1 0 0 0 0 2M25.46 26.98a1 1 0 1 0 0-2 1 1 0 0 0 0 2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#FF6726",
    d: "m5.45 12.01-.49-.87 11-6.13 10.99 6.13-.49.87-10.5-5.86z"
  })));
};
export default SvgHospitalinfoLodging;